module.exports = __webpack_public_path__ + "media/images/WinTAK_MIL-73e89313c679225aaa8c25643aeea33a.jpg";